module.exports = __webpack_public_path__ + "static/ten-thirty-user-avatar-icon-9f77a4a9eb175bb01bcf75b39975c452.svg";